import React, { useState } from 'react';
import { Box, Container, Typography, TextField, Button, Snackbar, Alert } from '@mui/material';
import AnimatedElement from './AnimatedElement';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
    gender: 3,
    message: '',
    secret_key: "fa2b646f7154e55b67c0d1eb4458b0e4",
  });

  const [loading, setLoading] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [hasError, setHasError] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      const res = await fetch(
        "https://brieftaube.kemto.de/api/subscription/message/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (!res.ok) {
        const err = await res.json();
        console.error("Backend Error:", err);
        throw new Error("Request failed");
      }

      await res.json();
      setHasError(false);

      setFormData({
        secret_key: "fa2b646f7154e55b67c0d1eb4458b0e4",
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        gender: 3,
        message: ''
      });

    } catch (err) {
      setHasError(true);
      console.error(err);
    } finally {
      setLoading(false);
      setShowAlert(true);
    }
  };

  return (
    <>
      <Snackbar
        open={showAlert}
        autoHideDuration={6000}
        onClose={() => setShowAlert(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setShowAlert(false)}
          severity={hasError ? 'error' : 'success'}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {hasError
            ? "Bitte versuchen Sie es später erneut!"
            : "Ihre Nachricht wurde erfolgreich übermittelt!"}
        </Alert>
      </Snackbar>

      <Box id="contact" sx={{ py: { xs: 8, md: 12 }, bgcolor: '#fff' }}>
        <Container maxWidth={false} sx={{ maxWidth: 1200, mx: 'auto', px: 2 }}>

          {/* Header */}
          <AnimatedElement>
            <Box sx={{ mb: 6 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { xs: '1.8rem', md: '2.4rem' },
                  fontWeight: 500,
                  color: '#000'
                }}
              >
                Kontakt aufnehmen
              </Typography>

              <Box sx={{ height: 4, width: 90, bgcolor: '#3a7b3e', mt: 2 }} />
            </Box>
          </AnimatedElement>

          {/* GRID */}
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
              gap: { xs: 6, md: 10 },
              alignItems: 'stretch'
            }}
          >

            {/* LEFT TEXT */}
            <AnimatedElement>
              <Box
                sx={{
                  position: 'relative',
                  height: '100%',
                  minHeight: { xs: 'auto', md: 360 }
                }}
              >
                {/* TEXT */}
                <Box>
                  <Typography sx={{ fontSize: '1.05rem', lineHeight: 1.7, color: '#111', mb: 2 }}>
                    Egal, ob Du Dir vorstellen kannst, bei uns aktiv zu werden oder einfach neue Leute kennenlernen möchtest — melde Dich gern!
                  </Typography>

                  <Typography sx={{ fontSize: '1.05rem', lineHeight: 1.7, color: '#111' }}>
                    Am besten bekommt man ein Gefühl für Guestphalia persönlich. Wir freuen uns auf Deine Nachricht.
                  </Typography>
                </Box>

                {/* WAPPEN ZENTRIERT */}
                <Box
                  component="img"
                  src="/Wachssiegel_mit_Wappen.png"
                  alt="Wachssiegel mit Wappen"
                  sx={{
                    position: { xs: 'static', md: 'absolute' },
                    left: { md: '50%' },
                    bottom: { md: 0 },
                    transform: { md: 'translateX(-50%)' },
                    width: { xs: 140, sm: 170, md: 220 },
                    maxWidth: '100%',
                    height: 'auto',
                    mt: { xs: 3, md: 0 },
                    display: 'block',
                    mx: { xs: 'auto', sm: 'auto', md: 0 }
                  }}
                />
              </Box>
            </AnimatedElement>

            {/* FORM */}
            <AnimatedElement>
              <Box
                component="form"
                onSubmit={handleSubmit}
                sx={{
                  p: { xs: 2, md: 4 },
                  border: '1px solid #e5e5e5',
                  borderRadius: 2,
                  bgcolor: '#fafafa'
                }}
              >
                <TextField
                  fullWidth
                  name="first_name"
                  label="Name"
                  value={formData.first_name}
                  onChange={handleInputChange}
                  required
                  sx={{ mb: 3 }}
                />

                <TextField
                  fullWidth
                  name="email"
                  label="E-Mail"
                  type="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  sx={{ mb: 3 }}
                />

                <TextField
                  fullWidth
                  name="message"
                  label="Nachricht"
                  multiline
                  rows={5}
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                  sx={{ mb: 3 }}
                />

                <Button
                  type="submit"
                  variant="contained"
                  disabled={loading}
                  sx={{
                    bgcolor: '#3a7b3e',
                    textTransform: 'none',
                    width: { xs: '100%', sm: 'auto' },
                    px: 4,
                    py: 1.5,
                    fontWeight: 500,
                    '&:hover': { bgcolor: '#2d5f31' }
                  }}
                >
                  {loading ? 'Wird gesendet…' : 'Absenden'}
                </Button>
              </Box>
            </AnimatedElement>

          </Box>
        </Container>
      </Box>
    </>
  );
};

export default ContactSection;
